import { createSelector } from 'reselect';
import { RootState } from 'src/store';
import { SceneVariable_GetSceneDataSelector } from 'src/types/sceneVariable';

const getScene = (state: RootState) => state.pages.editor.scene;
const getConfiguration = (state: RootState) => state.sceneConfiguration.activeLink;

const getSceneData = createSelector(
    [getScene, getConfiguration],
    (scene, configuration): SceneVariable_GetSceneDataSelector => {
        const { name, description, tags, notes, id, latestVersionId, publishedVersionId } = scene;
        const { sku, skuVersion, fixedAttributesSelection: attributes } = configuration;

        return {
            id,
            name,
            description,
            tags,
            notes,
            latestVersionId,
            publishedVersionId,
            sku,
            skuVersion,
            attributes,
        };
    },
);

export default getSceneData;
